import { Line } from '@models/line.model';
import { PartNumber } from '@models/partNumber.model';

export class ToolLifecycleHistory {

    public id: number;
    public toolUid: string;
    public toolName: string;
    public line: Line;
    public partNumber: PartNumber;
    public totalProductionCycles: number;
    public totalProductionTime: number;
    public date: string;
    public ticketId: string;

    static mapLine(line = {}) {
        return new Line(line || {});
    }

    static mapPartNumber(partNumber = {}) {
        return new PartNumber(partNumber || {});
    }

    constructor(toolLifecycleHistory: any = {}) {
        this.id = toolLifecycleHistory.id || 0;
        this.toolUid = toolLifecycleHistory.toolUid || '';
        this.toolName = toolLifecycleHistory.toolName || '';
        this.line = ToolLifecycleHistory.mapLine(toolLifecycleHistory.line);
        this.partNumber = ToolLifecycleHistory.mapPartNumber(toolLifecycleHistory.partNumber);
        this.totalProductionCycles = toolLifecycleHistory.totalProductionCycles || 0;
        this.totalProductionTime = toolLifecycleHistory.totalProductionTime || 0;
        this.date = toolLifecycleHistory.date || '';
        this.ticketId = toolLifecycleHistory.ticketId || '';
    }
}
